import { render, staticRenderFns } from "./export-bookmarks.vue?vue&type=template&id=423543d4"
import script from "./export-bookmarks.vue?vue&type=script&lang=js"
export * from "./export-bookmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports